import {trackEventBuyer, trackEventBuyerWithExtraParams, trackEventSeller} from "GTMs/libs";

export const gtmAddYourAdPostBtn = () => {
    trackEventSeller("InitAddPost", "AddPostBtn_Banner");
};


export const gtmVirtualCategories = (reportingName) => {
    trackEventBuyer(
        "InitChooseCategory",
        `VirtualCategoryCell_${reportingName}`
    );
};

export const gtmBannarCategory = (catReportingName:string) => {
    trackEventBuyerWithExtraParams('InitBrowse','Category_Section',{Category:catReportingName});
};
export const gtmContinueBrowsing = () => {
    trackEventBuyer("Browse", `ContinueBrowsing`);
};
export const gtmContinueBrowsingMoreBtn = () => {
    trackEventBuyer("Browse", `More_LatestAds`);
};

export const gtmMegaMenuCat = (category) => {
    trackEventBuyerWithExtraParams("InitBrowse", `Category_Menu`,{Category:category});
};

export const gtmMegaMenuSubCat = (category, subCategory) => {
    trackEventBuyerWithExtraParams("InitBrowse", `SubCategory_Menu_Menu`,{Category:category,SubCategory : subCategory});
};

export const gtmBannarBuyNowBtn = () => {
    trackEventBuyer("InitBrowse", `FindBtn_Banner`);
};

export const gtmSeeAllBtn = () => {
    trackEventBuyer(
        "Browse", `SeeAll_LatestAds`
    );
};

export const gtmPostLatestAds = (action , label ,extraData) => {
    trackEventBuyerWithExtraParams(
        action, label , extraData
    );
};
export const gtmMoreLatestAdsBtn = () => {
    trackEventBuyer(
        "Browse", `More_LatestAds`
    );
};
export const gtmCPLink = () => {
    trackEventBuyer(
        "InitBrowse", `CPLink`
    );
};

export const gtmLocationBottomLink = () => {
    trackEventBuyer(
        "InitBrowse", `LocationLink`
    );
};
